/* The purpose of this file to keep the reusable functions related to order-list */
import Routes from '@applications/order-tracker/route-constants';
import { Application } from '@applications/order-tracker';

/*
    This is a reusable function that is used in order-list and location-list
    This function check for feature flag and generates the route for order details page.
*/
export const getOrderDetailsRoutePath = (
  cidn: string,
  orderNum: string,
  useNewPage: boolean,
  isInternational?: boolean
): string => {
  const useUpliftedPage = (useNewPage && !isInternational);
  const page: string = useUpliftedPage
    ? Routes.ViewOrderDetailsNew(orderNum, cidn)
    : Routes.ViewOrderDetails(orderNum);
  const navUrlMulti: string = Application.routes.getPageSubpath(page);
  return useUpliftedPage ? navUrlMulti : `${navUrlMulti}?cid=${cidn}`;
};

export const getOrderListRoutePath = () => {
  return Routes.AppPrefix + Routes.OrderListBase;
}

export const getProductSheetRoutePath = (
  productOrderNumber: string,
  tab: string
): string => Routes.ViewOrderProductSheet(productOrderNumber, tab);

export const generateElementId = (value: string): string => {
  return `${value.toLowerCase().replace(/ /g, '-')}`;
};

export const refreshPage = () => window.location.reload();
